import { h, ComponentChildren } from "preact";

import classname from "../../../../foundation/utils/classname";
import Button, { ButtonProps, ButtonVariant } from "../../Button";
import NinjaTextButton, { NinjaTextButtonDisplay } from "../../NinjaTextButton";

import styles from "./RightPanelEmptyState.module.css";

enum RightPanelEmptyStateButtonVariant {
    Primary = "primary",
    Ninja = "ninja"
}

type RightPanelEmptyStateButtonProps = Pick<ButtonProps, "children" | "onClick" | "buttonRef"> & {
    variant?: RightPanelEmptyStateButtonVariant;
};

interface Props {
    class?: string;
    title: string;
    description: ComponentChildren;
    customContent?: ComponentChildren;
    buttonProps?: RightPanelEmptyStateButtonProps;
    linkContent?: ComponentChildren;
}

function RightPanelEmptyState({
    class: cssClass,
    title,
    description,
    customContent,
    buttonProps,
    linkContent
}: Props) {
    if (buttonProps) {
        buttonProps.variant ??= RightPanelEmptyStateButtonVariant.Primary;
    }

    const {
        variant: consumerButtonVariant, ...restOfButtonProps
    } = buttonProps ?? {} as Partial<RightPanelEmptyStateButtonProps>;
    const buttonVariant = buttonProps && !buttonProps.variant
        ? RightPanelEmptyStateButtonVariant.Primary
        : consumerButtonVariant;

    return (
        <div class={classname(styles.rightPanelEmptyState, cssClass)}>
            {title && <span class={classname(styles.title, "body-1 medium")}>{title}</span>}
            {description && <span class={classname(styles.description, "body-1")}>{description}</span>}
            {customContent && <div class={classname(styles.customContent, "body-1")}>{customContent}</div>}
            {buttonVariant === RightPanelEmptyStateButtonVariant.Primary && (
                <Button
                    class={styles.button}
                    variant={ButtonVariant.Primary}
                    {...restOfButtonProps}/>
            )}
            {buttonVariant === RightPanelEmptyStateButtonVariant.Ninja && (
                <NinjaTextButton
                    class={styles.ninjaButton}
                    display={NinjaTextButtonDisplay.Inline}
                    {...restOfButtonProps}/>
            )}
            {linkContent && <span class={classname(styles.linkContent, "body-1")}>{linkContent}</span>}
        </div>

    );
}

export default RightPanelEmptyState;
export {
    Props as RightPanelEmptyStateProps,
    RightPanelEmptyStateButtonVariant
};
